/**
 * BookingAccessoryService
 * Service for managing booking accessories
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for booking accessory CRUD operations with resource-specific queries
 */
export class BookingAccessoryService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BookingAccessoryService.DEFAULT_SERVICE_PATH,
            basePath: BookingAccessoryService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET BY RESOURCE ====================
    /**
     * Get all accessories for a specific bookable resource
     * @param resourceId - The bookable resource ID
     * @returns Array of booking accessories
     */
    async getByResource(resourceId) {
        const response = await this.getByResourceRaw(resourceId);
        return response.data ?? [];
    }
    /**
     * Get all accessories for a specific bookable resource with full response
     * @param resourceId - The bookable resource ID
     * @returns ResponseData with array of booking accessories
     */
    getByResourceRaw(resourceId) {
        const url = this.buildUrl(`by-resource/${resourceId}`);
        return this.http.get(url);
    }
}
BookingAccessoryService.DEFAULT_SERVICE_PATH = 'booking-management';
BookingAccessoryService.BASE_PATH = 'api/booking-accessories';
//# sourceMappingURL=BookingAccessoryService.js.map